import { jwtDecode } from './jwtDecode';

export const isTokenExpired = (token) => {
  if (!token) return true;    
  try {
    const decoded = jwtDecode(token);
    if (!decoded.payload.exp) return true;
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.payload.exp < currentTime;
  } catch (error) {
    console.error('Error decoding token:', error);
    return true;
  }
};

export const isTokenExpired2 = (token) => {
  if (!token) return true;
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    return decodedToken.payload.exp < currentTime;
  } catch (error) {
    console.error('Token decode error:', error);
    return true;
  }
};
